import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Create a <strong>CSV file</strong> with student information. Ensure columns match the expected format — typically name, email, and any required fields." id="create_a_csv_file_with_student_informati.4f3e1e7f" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Preparing Your File" id="preparing_your_file.16eb38c4" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Browse</strong> or drag your CSV file to upload. The system will validate the data and display a preview before importing." id="click_browse_or_drag_your_csv_file_to_up.1dcd194c" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Uploading Students" id="uploading_students.7dc0a5bb" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="After import, review the <strong>results summary</strong> to see how many students were created, updated, or skipped due to errors." id="after_import_review_the_results_summary.09a925cf" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Reviewing Results" id="reviewing_results.97aaadff" />
        }
    ],
    title: <FormattedMessage defaultMessage="Import Students" id="import_students.f041ccf5" />
};
